import { PermissionEnum } from "../Permission/PermissionEnum"

export default class UserRoleResponse{
    name?: string
    own_organisation_permissions? : PermissionEnum[]
    any_organisation_permissions? : PermissionEnum[]
}